"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldpayLabels = void 0;
const enums_1 = require("../../../../global/enums");
const WorldpayLabelsInEnglish = {
    merchantId: 'Merchant ID',
    terminalId: 'Terminal ID',
    accountNumber: 'Account #',
    entryMode: 'Entry method',
    pinVerified: 'PIN Verified',
    approvedAmount: 'Amount',
    approvalNumber: 'Approval Code',
    applicationLabel: 'Application Label',
};
const WorldpayLabelsInFrench = {
    merchantId: 'ID Marchand',
    terminalId: 'ID Term',
    accountNumber: 'Compte #',
    entryMode: "Mode d'entree",
    pinVerified: 'Vérifiée par NIP',
    approvedAmount: 'Montant',
    approvalNumber: 'Code de confirmation',
    applicationLabel: "Marque d'application",
};
exports.WorldpayLabels = {
    [enums_1.Language.ENGLISH]: WorldpayLabelsInEnglish,
    [enums_1.Language.FRENCH]: WorldpayLabelsInFrench,
};
//# sourceMappingURL=WorldpayLabels.js.map